module.exports = __webpack_public_path__ + "img/authorizationUrl.920da1fa.png";